import React from 'react';
import css from './ItemProgressBar.module.css';

interface ItemProgressBarProps {
    total: number;
    current?: number;
    unit?: string;
    divider?: string;
    selectedNotify?: string;

    progressTextClassName?: string;
    progressBarClassName?: string;
    progressScalePart?: string;
    progressScaleFill?: string;
}

const ItemProgressBar: React.FC<ItemProgressBarProps> = ({
    total,
    current,
    unit,
    divider = '/',
    selectedNotify = 'selected',

    progressTextClassName,
    progressBarClassName = css.progressBar,
    progressScalePart = css.scalePart,
    progressScaleFill = css.scaleFill,
}) => {
    const percentage = Math.min((current! / total) * 100, 100);

    return (
        <div className={progressBarClassName}>
            <div className={progressScalePart}>
                <div
                    className={progressScaleFill}
                    style={{
                        width: `${percentage}%`,
                    }}
                ></div>
            </div>
            <span
                className={
                    progressTextClassName
                        ? progressTextClassName
                        : css.scaleText
                }
            >
                <span className={css.scaleValues}>
                    {' '}
                    {current?.toFixed(0)} {unit}
                    {divider}
                    {total} {unit}
                </span>
                <span>{selectedNotify}</span>
            </span>
        </div>
    );
};

export default ItemProgressBar;
